import { useRef, useEffect } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n";
import Landing from "@/pages/Landing";
import NotFound from "@/pages/NotFound";
import LegalPage from "@/pages/LegalPage";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      const instance = lenisRef.current?.lenis;
      if (instance) {
        window.__lenis = instance;
        clearInterval(id);
      }
    }, 50);
    return () => clearInterval(id);
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ReactLenis root ref={lenisRef} options={{ lerp: 0.09, smoothWheel: true }}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<LegalPage type="privacy" />} />
            <Route path="/terms" element={<LegalPage type="terms" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <InstallPrompt />
          <Toaster position="top-center" richColors />
        </ReactLenis>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
